import { useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

const FIELDS = [
  ["judul", "Judul", false, "all"],
  ["keywords", "Kata kunci (pisahkan dengan koma)", false, "all"],
  ["konteks", "Wajib ada salah satu kata ini (opsional, koma)", false, "all"],
  ["edukasi", "Edukasi singkat", true, "keluhan"],
  ["segera", "Tanda bahaya (mis. \"Segera periksa bila: …\")", true, "keluhan"],
  ["layanan", "Layanan yang bisa membantu (koma)", false, "keluhan"],
  ["jawaban", "Jawaban (dikirim persis)", true, "katalog"],
  ["pesan_kedua", "Pesan kedua (opsional, dikirim setelah jawaban)", true, "katalog"],
];
const LISTS = ["keywords", "konteks", "layanan"];
const toForm = (it) => Object.fromEntries(FIELDS.map(([k]) => [k, LISTS.includes(k) ? (it?.[k] || []).join(", ") : it?.[k] || ""]));

export const ComplaintEditor = ({ item, onDone, onCancel }) => {
  const [f, setF] = useState(toForm(item));
  const [aktif, setAktif] = useState(item ? item.aktif : true);
  const [jenis, setJenis] = useState(item?.jenis || "keluhan");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const body = { ...f, aktif, jenis };
      if (item) await api.put(`/admin/clinara/complaints/${item.id}`, body);
      else await api.post("/admin/clinara/complaints", body);
      toast.success("Bank jawaban disimpan"); onDone();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  const remove = async () => {
    if (!window.confirm(`Hapus entri ${item.jenis === "katalog" ? "katalog" : "keluhan"} ini?`)) return;
    try { await api.delete(`/admin/clinara/complaints/${item.id}`); toast.success("Entri dihapus"); onDone(); }
    catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div data-testid="complaint-editor" className="my-2 space-y-2 rounded-xl border border-rose-100 bg-white p-3">
      <label className="block text-[11px] font-semibold text-slate-500">Jenis jawaban
        <select data-testid="complaint-field-jenis" value={jenis} disabled={!!item} onChange={(e) => setJenis(e.target.value)}
          className="mt-1 w-full rounded-lg border border-slate-200 p-2 text-sm font-normal text-slate-700">
          <option value="keluhan">Keluhan (pola informasi umum + tanda bahaya)</option>
          <option value="katalog">Katalog / harga (teks dikirim persis)</option>
        </select>
      </label>
      {FIELDS.filter(([, , , j]) => j === "all" || j === jenis).map(([k, label, area]) => (
        <label key={k} className="block text-[11px] font-semibold text-slate-500">{label}
          {area
            ? <textarea data-testid={`complaint-field-${k}`} rows={k === "jawaban" ? 8 : 3} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })}
                className="mt-1 w-full rounded-lg border border-slate-200 p-2 text-sm font-normal text-slate-700 focus:border-rose-300 focus:outline-none" />
            : <input data-testid={`complaint-field-${k}`} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })}
                className="mt-1 w-full rounded-lg border border-slate-200 p-2 text-sm font-normal text-slate-700 focus:border-rose-300 focus:outline-none" />}
        </label>
      ))}
      <label className="flex items-center gap-2 text-xs font-semibold text-slate-600">
        <input data-testid="complaint-field-aktif" type="checkbox" checked={aktif} onChange={(e) => setAktif(e.target.checked)} /> Aktif
      </label>
      <div className="flex flex-wrap gap-2">
        <button data-testid="complaint-save-btn" onClick={save} disabled={busy} className="rounded-xl bg-slate-700 px-3 py-1.5 text-xs font-bold text-white hover:bg-slate-800">Simpan</button>
        <button data-testid="complaint-cancel-btn" onClick={onCancel} className="rounded-xl bg-slate-100 px-3 py-1.5 text-xs font-bold text-slate-600 hover:bg-slate-200">Batal</button>
        {item && <button data-testid="complaint-delete-btn" onClick={remove} className="ml-auto rounded-xl bg-rose-50 px-3 py-1.5 text-xs font-bold text-rose-600 hover:bg-rose-100">Hapus</button>}
      </div>
    </div>
  );
};
